/*
 * assetUrl — resolve a static-asset path under the app's PUBLIC_URL prefix.
 *
 * Under the unified portal each SPA is served under a path prefix
 * (`/admin`, `/pitstop`); standalone/legacy builds have no prefix
 * (`PUBLIC_URL === ''`). Root-absolute asset paths like `/img/x.png` would
 * otherwise resolve to the shared origin root (the portal) and 404/return the
 * portal's index.html. Prefixing them with PUBLIC_URL points them at this
 * app's own assets.
 *
 * Guards (return untouched):
 *  - empty / falsy values
 *  - absolute URLs (http:, https:, data:, blob:, protocol-relative //) — e.g.
 *    backend-supplied S3 image URLs, which must NOT be prefixed
 *  - paths already carrying the prefix (e.g. webpack-bundled `/pitstop/static/*`)
 *
 * Legacy safety: PUBLIC_URL is '' in standalone builds, so the result is the
 * unchanged path — this helper is a no-op there.
 */
export function assetUrl(path) {
	// Defensive backstop: non-string (undefined/null/array/object) or empty → return
	// untouched. assetUrl is only for local hardcoded asset paths; backend data fields
	// must never be routed here, but guard anyway so a stray value can't crash `.startsWith`.
	if (!path || typeof path !== 'string') return path;
	if (/^(https?:|data:|blob:|\/\/)/.test(path)) return path;
	const base = process.env.PUBLIC_URL || '';
	if (base && path.startsWith(base + '/')) return path;
	return base + (path.startsWith('/') ? path : '/' + path);
}

export default assetUrl;
